import { v4 as uuid } from 'uuid'
import type { BodyType } from '../schemas'
import { EntityTypes } from '../enums/entityTypes'

export function createDefaultEmailBody(): BodyType {
  return {
    id: uuid(),
    type: EntityTypes.Body,
    childIds: [],
  }
}
